/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Button, Card, CardContent, FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import Grid from "@mui/material/Grid";
import { GridSearchIcon } from "@mui/x-data-grid";
import axios from "axios";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import MDButton from "components/MDButton";
import DeleteModal from "components/deletemodal/deletemodal";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { createTheme } from "react-data-table-component";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from "react-redux";
import { appConstants } from "utils/appConstants";
import { generateDataList, getScreenRight, showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import LoadingModal from "../../components/LoadingModel/loadingModal";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import IconMenu from "components/CustomMaterialMenu/Custom";
import { fetchItemsForReport } from "utils/api";
import { formatCurrencyAUD } from "utils/formatCurrency";


let searchParameter = "";
let itemStatus = "Active";
let categoryName = "All";
let categoryCodeName = "All";
let SCREEN_NAME = "";
let SCREEN_RIGHT;

createTheme(
  'solarized',
  {
    text: {
      primary: 'white',
      secondary: 'white',
    },
    background: {
      default: '#202940',
    },
    context: {
      background: '#202940',
      text: 'white',
    },
    divider: {
      default: 'white',
    },
    sortFocus: {
      default: '#2aa198',
    },
  },
  'dark',
);
createTheme(
  'light',
  {
    text: {
      primary: 'black',
      secondary: 'black',
    },
    background: {
      default: 'white',
    },
    context: {
      background: 'white',
      text: 'black',
    },
    divider: {
      default: 'gray',
    },
    sortFocus: {
      default: '#2aa198',
    },
  },
  'dark',
);

function ReportForItem() {
  //Starts here change the pagination text Rows per page to Record per page
  // let changePaginationText = document.getElementsByClassName("rdt_Pagination")[0];
  // if (changePaginationText !== undefined) {
  //   changePaginationText.getElementsByTagName('span')[0].textContent = "Records Per Page";
  // }
  const { id } = useParams();
  let currency = useSelector((state) => state.currency.currencySymbol);
  const navigate = useNavigate()
  //ends here change the pagination text Rows per page to Record per page
  const [loading, setLoading] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [deleteHeading, setDeleteHeading] = useState("");
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [title, setTitle] = useState("");
  const [controller] = useMaterialUIController();
  const dispatch = useDispatch();
  const { darkMode, sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);
  const [screenAccess, setScreenAccess] = useState(false);
  const [values, setValues] = useState({
    _id: '',
    sortingType: "",
    sortingField: "",
    itemStatus: "All",
    categoryName: "All",
    categoryCodeName: "All",
    durationDate: "",
    fromDate: "",
    toDate: "",
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
    searchParameterList: ['categoryName', 'itemName', 'itemCode', 'unitOfMeasurement', 'itemStatus', 'categoryCodeName'],
    businessUserID: JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'))?.businessUserID,
  });

  const [itemCategoriesName, setItemCategoriesName] = useState([]);

  useEffect(() => {
    (async () => {
      const reportType = sessionStorage.getItem('reportType');// get value first
      if (reportType === 'InvoiceItems') {
        SCREEN_NAME = 'Invoice Items'
        console.log("SCREEN_NAMEs", SCREEN_NAME);
      } else if (reportType === 'RctiItems') {
        SCREEN_NAME = 'RCTI Items'
      } else if (reportType === 'QuotationItems') {
        SCREEN_NAME = 'Quotation Items'
      }
      await fetchItem();
    })();

  }, [values.categoryName, values.categoryCodeName, values.itemStatus, values.sortingType, perPage, dispatch]);









  const handlePageChange = page => {
    values.page = page;
    fetchItem();
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setToggleCleared(!toggleCleared);
    setSelectedRows([]);
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
  };

  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
  };



  const handleRowSelected = useCallback(state => {
    let data = state.selectedRows
    if (data.length > 0) {
      setSelectedRows(
        data.map((a) =>
          a._id
        ))
      setTitle(" ")

    }
    else {
      setTitle("");
      setDeleteHeading("");
    }
  }, []);


  // const fetchItem = async () => {
  //   let reportType = JSON.parse(sessionStorage.getItem('reportType')),
  //     await fetchItemsForReport({ id: id }, (data) => {
  //       console.log("datass", data)
  //       setTotalRows(data.Result_Output.totalDocs);
  //       setRows(data.Result_Output.docs)
  //     }, dispatch)
  // };

  const fetchItem = async () => {

    const reportType = sessionStorage.getItem('reportType');// get value first
    console.log("reportType", reportType);

    await fetchItemsForReport(
      { id: id, type: reportType }, // pass if needed
      (data) => {
        console.log("datass", data);
        setTotalRows(data.Result_Output.totalDocs);
        setRows(data.Result_Output.docs);
      },
      dispatch
    );
  };

  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  const handleBack = () => {

    const reportType = sessionStorage.getItem('reportType');// get value first

    if (reportType === 'InvoiceItems') {
      navigate("/invoiceReport")

    } else if (reportType === 'RctiItems') {
      navigate("/rctiReport")

    } else if (reportType === 'QuotationItems') {
      navigate("/quotationReport")

    }

  }

  const customStyles = {
    table: {
      style: {
        borderColor: tableBorder,
      },
    },
    headRow: {
      style: {
        color: darkMode ? "white" : "white",
        background: barColor,
      },
    },
    headCells: {
      style: {
        // paddingLeft: '10px',
        // paddingRight: '10px',
        fontWeight: 'bold',
        fontSize: '14px',
        color: "white",

      },
    },
  };

  let columns = [

    {
      // name: "Item Name",
      name: <p style={{ paddingLeft: "20px", fontSize: "12px" }}>Item Name</p>,
      // selector: row => row.itemName,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.itemName}</span>
      ),
      sortable: true,
      sortField: 'itemName',
      style: { paddingLeft: "10px" },
      center: true,

    },

    {
      // name: "Item Code",
      name: <p style={{ paddingLeft: "20px", fontSize: "12px" }}>Item Code</p>,
      // selector: row => row.itemCode,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.itemCode}</span>
      ),
      sortable: true,
      sortField: 'itemCode',
      center: true,
    },

    {
      // name: "Status",
      name: <p style={{ paddingLeft: "15px", fontSize: "12px" }}>Status</p>,
      // selector: row => row.itemStatus,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.itemStatus}</span>
      ),
      sortable: true,
      sortField: 'itemStatus',
      center: true,
    },

    {
      // name: "Item Category Name",
      name: <p style={{ fontSize: "12px" }}>Account Name</p>,
      // selector: row => row.categoryName,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.categoryCodeName}</span>
      ),
      sortable: true,
      sortField: 'categoryCodeName',

    },
    {
      name: <p style={{ fontSize: "12px" }}>{`Item Price (${currency})`}</p>,
      selector: row => formatCurrencyAUD(row.itemPrice),
      sortable: true,
      sortField: 'itemPrice',
      center: true,
      minWidth: '140px'
    },

    {
      name: <p style={{ fontSize: "12px" }}>Item Quantity</p>,
      selector: row => row.itemQuantity,
      sortable: true,
      sortField: 'itemQuantity',
      center: true,
      minWidth: '140px'
    },
    {
      name: <p style={{ fontSize: "12px" }}>Discount Type</p>,
      selector: row => row.discountType,
      sortable: true,
      sortField: 'discountType',
      center: true,
      minWidth: '140px'
    },
    {
      name: <p style={{ fontSize: "12px" }}>{`Discount Amount (${currency})`}</p>,
      selector: row => formatCurrencyAUD(row.discountAmount),
      sortable: true,
      sortField: 'discountAmount',
      center: true,
      minWidth: '160px'
    },
    {
      name: <p style={{ fontSize: "12px" }}>GST(%)</p>,
      selector: row => row.gst,
      sortable: true,
      sortField: 'gst',
      center: true,
      minWidth: '140px'
    },


  ];




  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: '20px' }}>
        <Card color="primary">
          <PageTitle screenName={SCREEN_NAME} />
          <Grid container display={"flex"} justifyContent="end" mt={2} gap={2} px={2} >
            <MDButton
              variant="contained"
              color="success"
              style={{ height: "38.11px" }}
              onClick={handleBack}
            >
              Back
            </MDButton>
          </Grid>
          {/* <CardContent> */}
          <BTable
            theme={darkMode ? 'solarized' : 'light'}
            title={title}
            columns={columns}
            data={rows}
            selectable
            selectableRows={screenAccess ? true : false}
            sortingType={handleSort}
            sortServer
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            customStyles={customStyles}
            // contextActions={contextActions}
            onSelectedRowsChange={handleRowSelected}
            clearSelectedRows={toggleCleared}
            fixedHeaderScrollHeight="410px"
            fixedHeader={true}
          />
          {/* </CardContent> */}
        </Card>
      </div >

      <LoadingModal loading={loading} />

    </DashboardLayout>
  );

}

export default ReportForItem;
